import MarutiGreens from './img/maruti-greens.png'
import MarutiPearl from './img/maruti-pearl.png'
import AnandPlaza from './img/anand-plaza.png'
import ShaktiApartments from './img/shakti-apartment.png'
import KrishnaGardens from './img/krishna-gardens.png'
import BalajiGreens from './img/balaji-greens.png'
import GomtiPlaza from './img/gomti-palza.png'
import JagatComplex from './img/jagat-complex.png'
import SiddharthApartments from './img/siddharth-apartments.png'

export const projectsData = [
    {
        title: 'Maruti Greens',
        address: 'Near Unique Park, Behala, Kolkata',
        tag: 'Residential Building',
        img: MarutiGreens
    },
    {
        title: 'Maruti Pearl',
        address: 'Shakuntala Park, Behala, Kolkata',
        tag: 'G+3 floor Residential Building',
        img: MarutiPearl
    },
    {
        title: 'Anand Plaza',
        address: 'Patrakarpuram Crossing, Lucknow',
        tag: 'Commercial Building',
        img: AnandPlaza
    },
    {
        title: 'Shakti Apartments',
        address: 'New Alipore Gardens, Kolkata',
        tag: 'G+5 floors Residential Building',
        img: ShaktiApartments
    },
    {
        title: 'Shri Krishna Gardens',
        address: 'New Alipore Gardens, Kolkata',
        tag: 'G+4 floors Residential Building',
        img: KrishnaGardens
    },
    {
        title: 'Balaji Greens',
        address: 'Behla Chowrasta/Ketopole, Kolkata',
        tag: '5 Residential blocks with G+4 floors',
        img: BalajiGreens
    },
    {
        title: 'Gomti Plaza',
        address: 'Lucknow',
        tag: 'Commercial Complex',
        img: GomtiPlaza
    },
    {
        title: 'Jagat Complex',
        address: 'Lucknow',
        tag: 'Commercial Complex',
        img: JagatComplex
    },
    {
        title: 'Siddharth Apartments',
        address: 'Regent Park, Tollygunge,Kolkata',
        tag: 'Residential Building',
        img: SiddharthApartments
    },
]